import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, TextField } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../../functions/axios';
import { parseDate } from '../../functions/functions';
import { useAuthContext } from '../../hooks/useAuthContext';
import { DateSelectorSingle } from './DateSelectorSingle';
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const NoteEdit = () => {
  const { user } = useAuthContext();
  const [originalNote, setOriginalNote] = useState(null);
  const [driverIdForm, setDriverIdForm] = useState(null);
  const [note, setNote] = useState('');
  const [dateForm, setDateForm] = useState(parseDate().day);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const id = location.pathname.split('/').pop();
        const response = await axios.get('/notes', { params: { id, context: 'carriageNotes' } });
        setDateForm(parseDate(response.data?.date).day);
        setDriverIdForm(response.data?.driver?._id);
        setNote(response.data?.value);
        setOriginalNote(response.data);
      } catch (err) {
        console.log(err);
      }
    })();
  }, [user, location]);

  const deleteRecord = useCallback(async () => {
    if (!originalNote) return;
    const confirmBox = window.confirm('Czy na pewno usunąć ten wpis?');
    if (!confirmBox) return;

    try {
      await axios.delete('/notes', { data: { _id: originalNote._id, context: 'carriageNotes' } });
      await wait(500);
      navigate('/carriageNotes', { state: { date: dateForm } });
    } catch (err) {
      console.log(err);
    }
  }, [dateForm, navigate, originalNote]);

  const postNoteData = useCallback(async () => {
    try {
      await axios.patch('/notes', {
        ...originalNote,
        date: dateForm,
        driver: driverIdForm,
        value: note,
        context: 'carriageNotes',
      });
      navigate('/carriageNotes', { state: { date: dateForm } });
    } catch (err) {
      console.log(err);
    }
  }, [dateForm, driverIdForm, navigate, note, originalNote]);

  if (!user) return null;

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 80px)' }}>
      <Box style={{ margin: '0 25px', display: 'flex', gap: '25px', alignItems: 'center', flexShrink: 0 }}>
        <DateSelectorSingle date={dateForm} setDate={setDateForm} />
      </Box>
      <Box style={{ padding: '25px', width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
        <TextField
          style={{ color: 'white', flex: 1 }}
          value={note}
          fullWidth
          label='Notatka'
          multiline
          variant='outlined'
          onChange={(e) => setNote(e.target.value)}
          sx={{
            '& .MuiInputBase-root': {
              height: '100%',
              alignItems: 'flex-start',
            },
            '& .MuiInputBase-input': {
              height: '100% !important',
              overflow: 'auto !important',
            }
          }}
        />
      </Box>
      <Box style={{ display: 'flex', padding: '25px', width: '100%', justifyContent: 'space-between', flexShrink: 0 }}>
        <Button variant='outlined' style={{ width: '250px' }} onClick={navigate.bind(null, `/carriageNotes`, { state: { date: dateForm } })}>
          Wróć do listy
        </Button>
        <Box style={{ display: 'flex', gap: '20px' }}>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              deleteRecord();
            }}
            variant='outlined'
            color='error'
          >
            <DeleteIcon
              sx={{
                width: '28px',
                height: '28px',
                color: '#f44336',
                cursor: 'pointer',
                transition: 'color 0.15s',
                '&:hover': { color: '#ff7961' },
              }}
            />
            Usuń
          </Button>
          <Button disabled={!note} variant='contained' style={{ width: '250px' }} onClick={postNoteData} startIcon={<SaveIcon />}>
            Zapisz
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NoteEdit;
